<!-- tailwind with primeng combined navbar, starting with nav HTML tag -->

<nav
	class="global-navbar bg-white rounded-md fixed w-full top-0 left-0 m-0 p-0"
>
	<div class="container mx-auto px-4">
		<div class="flex items-center justify-between h-16">
			<div class="flex items-center">
				<button
					pButton
					(click)="globalSidenavService.visible.set(true)"
					severity="contrast"
				>
					<i class="pi pi-bars"></i>
				</button>
			</div>
		</div>
	</div>
</nav>
